// English version of the Swahili (Kenya / Tanzania) cultural quiz — same ids/option order as miniGamesData.ts
import { QuizEn } from './types';

export const SWAHILI_EN: Record<string, QuizEn> = {
  // ── History ──
  'sw-h-1': {
    q: "Which coastal city is considered the cradle of Swahili culture and language?",
    o: ["Mombasa", "Nairobi", "Dar es Salaam", "Zanzibar"],
    e: "Mombasa, on the Kenyan coast, is one of the historic centres of Swahili civilisation, which developed through trade between Africa, the Arabian Peninsula and South Asia.",
  },
  'sw-h-2': {
    q: "Which major revolt against British colonial rule took place in Kenya in the 1950s?",
    o: ["The Mau Mau rebellion", "The Zulu rebellion", "The Maji Maji revolt", "Samori's resistance"],
    e: "The Mau Mau rebellion (1952–1960) was an armed uprising, mainly by the Kikuyu, against British colonial rule. It helped speed up Kenya's independence in 1963.",
  },
  'sw-h-3': {
    q: "Who was the first president of independent Kenya in 1963?",
    o: ["Jomo Kenyatta", "Daniel arap Moi", "Mwai Kibaki", "Uhuru Kenyatta"],
    e: "Jomo Kenyatta (c. 1897–1978) was the founding father and first president of independent Kenya, in office from 1963 until his death in 1978.",
  },
  'sw-h-4': {
    q: "Which Arab sultanate controlled Zanzibar and the Swahili coast before European colonisation?",
    o: ["The Sultanate of Oman", "The Sultanate of Morocco", "The Sultanate of Persia", "The Zanzibari Sultanate"],
    e: "The sultans of Oman established their hold over Zanzibar and the East African coast in the 17th–19th centuries. In 1840, Sultan Said bin Sultan even moved his capital from Muscat to Zanzibar.",
  },
  'sw-h-5': {
    q: "Tanzania is the result of the union of which two territories in 1964?",
    o: ["Tanganyika and Zanzibar", "Kenya and Uganda", "Mozambique and Malawi", "Rwanda and Burundi"],
    e: "Tanzania was born in 1964 from the union of Tanganyika (independent since 1961) and Zanzibar (independent since 1963), creating the United Republic of Tanzania.",
  },
  'sw-h-6': {
    q: "Which ancient trade route connected East Africa to Asia and spread the Swahili language?",
    o: ["The Maritime Silk Road", "The Gold Route", "The Saharan caravan trail", "The Nile Route"],
    e: "The Maritime Silk Road crossed the Indian Ocean, linking the coasts of East Africa with Arabia, India and China. This trade shaped Swahili culture and language.",
  },
  'sw-h-7': {
    q: "Which great European explorer reached the source of the Nile by way of East Africa?",
    o: ["John Hanning Speke", "Henry Morton Stanley", "Vasco da Gama", "David Livingstone"],
    e: "John Hanning Speke was the first European to reach Lake Victoria in 1858 and identified it as the main source of the Nile, during an expedition with Richard Burton.",
  },
  'sw-h-8': {
    q: "Which Tanzanian revolt against German colonial rule, inspired by belief in a protective magic water, broke out in 1905?",
    o: ["The Maji Maji revolt", "The Mau Mau rebellion", "The Hehe revolt", "The Bushiri revolt"],
    e: "The Maji Maji revolt (1905–1907) was the largest uprising against German colonial rule in East Africa. 'Maji' means 'water' in Swahili, referring to the sacred water believed to make fighters invulnerable. The repression killed between 200,000 and 300,000 people.",
  },
  'sw-h-9': {
    q: "Which Portuguese navigator rounded the Cape of Good Hope and reached Mombasa in 1498?",
    o: ["Vasco da Gama", "Bartolomeu Dias", "Pedro Álvares Cabral", "Ferdinand Magellan"],
    e: "Vasco da Gama arrived at Mombasa and Malindi in 1498 on his voyage to India. His arrival marked the beginning of Portuguese influence on the Swahili coast, which they partly controlled until the 18th century.",
  },
  'sw-h-10': {
    q: "Which Hehe chief resisted the Germans in mainland Tanzania until 1898?",
    o: ["Mkwawa", "Mirambo", "Nyungu ya Mawe", "Kimweri"],
    e: "Mkwawa (1855–1898) was the paramount chief (Mtwa) of the Hehe people. He inflicted a crushing defeat on the Germans at Lugalo in 1891, then resisted for seven years before taking his own life rather than be captured. His skull, taken by the Germans, was returned to Tanzania in 1954.",
  },
  'sw-h-11': {
    q: "Which first president of Tanzania is famous for his African socialism policy called 'Ujamaa'?",
    o: ["Julius Nyerere", "Ali Hassan Mwinyi", "Benjamin Mkapa", "Jakaya Kikwete"],
    e: "Julius Nyerere (1922–1999) led Tanzania from 1961 to 1985. His Ujamaa policy ('familyhood' in Swahili) aimed at a self-reliant African socialism, notably through the villagisation of land in the 1970s. He is nicknamed 'Mwalimu' (the teacher).",
  },
  'sw-h-12': {
    q: "Which Swahili city-state, whose ruins are a UNESCO site, was one of the largest medieval ports of the Indian Ocean?",
    o: ["Kilwa Kisiwani (Tanzania)", "Lamu (Kenya)", "Malindi (Kenya)", "Pate (Kenya)"],
    e: "Kilwa Kisiwani, on the Tanzanian coast, was one of the most important trading cities of the Indian Ocean in the 13th–16th centuries. It controlled the gold trade from Zimbabwe. Its ruins are a UNESCO World Heritage Site.",
  },
  'sw-h-13': {
    q: "Kenya became independent on 12 December 1963. What title did Jomo Kenyatta hold at independence?",
    o: ["Prime Minister, then President", "King", "Governor-General", "Chancellor"],
    e: "On 12 December 1963, Jomo Kenyatta became Prime Minister of independent Kenya. On 12 December 1964, Kenya became a republic and Kenyatta its first president.",
  },
  'sw-h-14': {
    q: "Which 1886 treaty between Germany and Great Britain delimited their spheres of influence in East Africa?",
    o: ["Heligoland–Zanzibar Treaty (1890)", "Treaty of Berlin (1885)", "Anglo-German Agreement of 1886", "Treaty of Versailles"],
    e: "The 1890 Heligoland–Zanzibar Treaty between Great Britain and Germany clarified their spheres of influence: Germany obtained German East Africa (Tanzania), Great Britain Kenya and Uganda, in exchange for the island of Heligoland in the North Sea.",
  },

  // ── Politics ──
  'sw-p-1': {
    q: "What is the capital of Kenya?",
    o: ["Nairobi", "Mombasa", "Kisumu", "Nakuru"],
    e: "Nairobi is the capital and largest city of Kenya, founded in 1899 as a railway depot. Today it is one of the largest economic centres in East Africa.",
  },
  'sw-p-2': {
    q: "What is the capital of Tanzania?",
    o: ["Dodoma", "Dar es Salaam", "Zanzibar", "Mwanza"],
    e: "Dodoma has been Tanzania's official capital since 1974. However, Dar es Salaam remains the largest city and the country's main economic centre.",
  },
  'sw-p-3': {
    q: "What is Kenya's currency?",
    o: ["Kenyan shilling", "CFA franc", "Tanzanian shilling", "Euro"],
    e: "Kenya uses the Kenyan shilling (KES), introduced in 1966 to replace the East African shilling. Tanzania uses the Tanzanian shilling (TZS).",
  },
  'sw-p-4': {
    q: "Which regional economic community do Kenya and Tanzania belong to?",
    o: ["EAC (East African Community)", "ECOWAS", "SADC only", "COMESA only"],
    e: "Kenya and Tanzania are both members of the East African Community (EAC), founded in 1999, which aims at regional economic integration.",
  },
  'sw-p-5': {
    q: "Which Kenyan president succeeded Uhuru Kenyatta in 2022?",
    o: ["William Ruto", "Raila Odinga", "Uhuru Kenyatta Jr.", "Martha Karua"],
    e: "William Ruto was elected president of Kenya in August 2022, winning a hotly contested election against Raila Odinga. The electoral commission declared him the winner with 50.5% of the vote.",
  },
  'sw-p-6': {
    q: "What is Tanzania's political system?",
    o: ["Presidential republic", "Monarchy", "Military regime", "Royal federation"],
    e: "Tanzania is a presidential republic, historically with a dominant single party, although multi-party politics has been allowed since 1992.",
  },
  'sw-p-7': {
    q: "Which major United Nations headquarters is based in Nairobi?",
    o: ["UNEP (United Nations Environment Programme)", "FAO", "UNICEF", "WHO"],
    e: "UNEP has had its headquarters in Nairobi since 1972. It is the only headquarters of a major UN body based in a developing country.",
  },
  'sw-p-8': {
    q: "Which Tanzanian president succeeded John Pombe Magufuli after his death in March 2021?",
    o: ["Samia Suluhu Hassan", "Anna Tibaijuka", "Asha-Rose Migiro", "Jakaya Kikwete"],
    e: "Samia Suluhu Hassan became president of Tanzania on 19 March 2021, after the death of President John Pombe Magufuli. She is the first woman to lead Tanzania and one of the few female heads of state in Africa.",
  },
  'sw-p-9': {
    q: "Which internationally known Kenyan body has stood out in the fight against corruption in Africa?",
    o: ["KACC / EACC", "Kenya Revenue Authority", "IEBC", "DCI Kenya"],
    e: "The Kenya Anti-Corruption Commission (formerly KACC, now the EACC, Ethics and Anti-Corruption Commission) was set up to fight corruption. Kenya is also a member of the Extractive Industries Transparency Initiative (EITI).",
  },
  'sw-p-10': {
    q: "Which highly progressive Kenyan constitution, adopted in 2010, introduced major devolution to the counties?",
    o: ["The 2010 Constitution", "The 1963 Constitution", "The 1991 Constitution", "The Naivasha Agreement"],
    e: "Kenya's 2010 Constitution, adopted by referendum, transformed the system of governance by creating 47 counties with elected governments and their own budgets. It is one of the most progressive constitutions in Africa.",
  },
  'sw-p-11': {
    q: "Kenya is one of Africa's main exporters of which agricultural product to Europe?",
    o: ["Tea", "Cocoa", "Arabica coffee", "Cotton"],
    e: "Kenya is the world's third-largest tea producer and Africa's leading exporter. The highland tea gardens (Kericho region) produce a high-quality black tea much prized in Europe and Asia.",
  },
  'sw-p-12': {
    q: "Which Tanzanian city, a former colonial capital, is home to the country's main port?",
    o: ["Dar es Salaam", "Dodoma", "Tanga", "Mwanza"],
    e: "Dar es Salaam ('haven of peace' in Arabic) is Tanzania's largest city and main port. Despite the official transfer of the capital to Dodoma (1974), most government offices remain in Dar es Salaam.",
  },
  'sw-p-13': {
    q: "Which Kenyan protest movement of June 2024 was triggered by the finance bill and forced President Ruto to make concessions?",
    o: ["The Gen Z anti-Finance Bill movement", "Kenya Kwanza protests", "Azimio demonstrations", "Wanjiku Revolution"],
    e: "In June 2024, young Kenyans (nicknamed 'Gen Z') protested against the Finance Bill 2024, which planned major tax increases. The protests, organised via social media, led President William Ruto to withdraw the bill.",
  },
  'sw-p-14': {
    q: "Tanzania is known for preserving its wildlife. What percentage of its territory is classified as protected areas or national parks?",
    o: ["About 38%", "About 5%", "About 15%", "About 60%"],
    e: "Tanzania protects about 38% of its territory as national parks, game reserves and conservation areas, making it one of the best-protected countries in Africa. It is home to the Serengeti, Ngorongoro, Selous and many other parks.",
  },

  // ── Geography ──
  'sw-g-1': {
    q: "What is the highest peak in Africa, located in Tanzania?",
    o: ["Kilimanjaro", "Mount Kenya", "Mount Elgon", "The Rwenzori"],
    e: "Kilimanjaro rises to 5,895 m, making it the highest peak in Africa. It is located in northern Tanzania, near the Kenyan border.",
  },
  'sw-g-2': {
    q: "Which lake, the largest in Africa, lies on the borders of Kenya, Tanzania and Uganda?",
    o: ["Lake Victoria", "Lake Tanganyika", "Lake Malawi", "Lake Turkana"],
    e: "Lake Victoria, at 68,800 km², is the largest lake in Africa and the second-largest freshwater lake in the world. It is shared by Kenya, Tanzania and Uganda.",
  },
  'sw-g-3': {
    q: "Which national park is famous for the 'Great Migration' of wildebeest in Tanzania and Kenya?",
    o: ["Serengeti / Maasai Mara", "Amboseli", "Tsavo", "Ngorongoro"],
    e: "The Great Migration is the annual movement of over a million wildebeest between Tanzania's Serengeti and Kenya's Maasai Mara. It is one of the most impressive natural spectacles in the world.",
  },
  'sw-g-4': {
    q: "Which ocean borders the east coast of Kenya and Tanzania?",
    o: ["The Indian Ocean", "The Atlantic", "The Pacific", "The Arctic"],
    e: "Kenya and Tanzania have a long Indian Ocean coastline, which historically facilitated trade with Arabia, India and South-East Asia.",
  },
  'sw-g-5': {
    q: "Which famous spice island is a semi-autonomous region of Tanzania?",
    o: ["Zanzibar", "Pemba", "Mafia", "Réunion"],
    e: "Zanzibar is a Tanzanian archipelago in the Indian Ocean, made up mainly of the islands of Unguja (Zanzibar) and Pemba. It is famous for its spices and Swahili architecture.",
  },
  'sw-g-6': {
    q: "The East African Rift runs through both countries. What spectacular geological features result from it?",
    o: ["Lakes, volcanoes and deep valleys", "Salt deserts", "Equatorial forests", "Ice plateaus"],
    e: "The Great Rift Valley is a fracture in the Earth's crust creating deep valleys, lakes and volcanic activity. It runs through the whole of East Africa from north to south.",
  },
  'sw-g-7': {
    q: "Which volcanic crater in Tanzania is the world's largest intact one and forms a unique ecosystem?",
    o: ["Ngorongoro Crater", "Kilimanjaro crater", "Nyiragongo crater", "Longonot caldera"],
    e: "Ngorongoro Crater, about 20 km across, is the world's largest intact volcanic crater. A UNESCO World Heritage Site, it is home to exceptionally dense wildlife.",
  },
  'sw-g-8': {
    q: "Which lake in Kenya's Rift Valley is famous for its millions of pink flamingos?",
    o: ["Lake Nakuru", "Lake Turkana", "Lake Baringo", "Lake Magadi"],
    e: "Lake Nakuru National Park (Kenya) is famous for hosting from hundreds of thousands to over a million flamingos feeding on the algae of the alkaline lake. It is also one of the last refuges of Kenya's white rhinos.",
  },
  'sw-g-9': {
    q: "What is the largest lake in Kenya, located in the western Rift Valley?",
    o: ["Lake Turkana", "Lake Nakuru", "Lake Baringo", "Lake Naivasha"],
    e: "Lake Turkana (formerly Lake Rudolf) is the world's largest desert lake and the fourth-largest lake in Africa. Located in northern Kenya, it is a UNESCO World Heritage Site.",
  },
  'sw-g-10': {
    q: "What is the approximate area of Tanzania?",
    o: ["945,000 km²", "200,000 km²", "1,500,000 km²", "580,000 km²"],
    e: "Tanzania covers 945,087 km², making it one of the largest countries in eastern sub-Saharan Africa. That is about four times the area of Great Britain.",
  },
  'sw-g-11': {
    q: "Which Tanzanian national park, one of the largest in Africa, is known for its elephants and inland delta?",
    o: ["Selous Reserve (Nyerere)", "Serengeti", "Ruaha", "Katavi"],
    e: "The Selous Reserve, renamed Nyerere National Park in 2019, is one of the largest nature reserves in Africa (50,000 km²). It is home to Africa's largest population of wild elephants and is a UNESCO World Heritage Site.",
  },
  'sw-g-12': {
    q: "Which semi-nomadic cattle-herding people live in the Kenya–Tanzania border areas around the Serengeti?",
    o: ["The Maasai", "The Kikuyu", "The Luo", "The Chagga"],
    e: "The Maasai are a semi-nomadic Nilotic people whose traditional territory stretches from Kenya's Rift Valley to the plains of Tanzania's Serengeti. They are famous for their culture, ornaments and pastoral way of life.",
  },
  'sw-g-13': {
    q: "Which sea strait separates the island of Zanzibar from mainland Tanzania?",
    o: ["The Zanzibar Channel", "The Mozambique Channel", "The Bab-el-Mandeb Strait", "The Pemba Strait"],
    e: "The Zanzibar Channel separates the main island of Zanzibar (Unguja) from the African mainland by about 35 km. This proximity historically facilitated commercial and cultural exchanges.",
  },
  'sw-g-14': {
    q: "Which Kenyan mountain, Africa's second-highest peak, gave the country its name?",
    o: ["Mount Kenya (5,199 m)", "Mount Elgon (4,321 m)", "Aberdare (4,001 m)", "Longonot (2,776 m)"],
    e: "Mount Kenya rises to 5,199 m (Batian Peak) and is Africa's second-highest peak. It gave its name to the nation. It is an ancient stratovolcano whose summit glaciers are retreating rapidly due to climate change.",
  },
};
